var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldRender)?_c('div',{staticClass:"logotype"},[(_vm.logo)?_c('img',{staticClass:"logotype-image",attrs:{"src":_vm.logo,"alt":"Logo"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }